import { render, staticRenderFns } from "./ReportCreate.vue?vue&type=template&id=2222643a&scoped=true&"
import script from "./ReportCreate.vue?vue&type=script&lang=js&"
export * from "./ReportCreate.vue?vue&type=script&lang=js&"
import style0 from "./ReportCreate.vue?vue&type=style&index=0&id=2222643a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222643a",
  null
  
)

export default component.exports